import { scaleOrdinal } from '@visx/vendor/d3-scale';
import scaleOperator from "../operators/scaleOperator.js";
export const updateOrdinalScale = scaleOperator('domain', 'range', 'reverse', 'unknown');
export default function createOrdinalScale(config) {
  return updateOrdinalScale(scaleOrdinal(), config);
}